import { valueof } from '@flipster/utils/typescript';

/**
 * 로그인을 위해서 이메일 인증(level1)을 거쳐야 하기 때문에
 * kyc페이지에서는 level1은 무조건 통과된 상태이므로 상태값이 필요없음
 */
export interface UserKycStatus {
  currentKYCLevel: KycLevelType;
  desirableKYCLevel: KycLevelType;
  level2SimpleStatus: KycLevelStatusType;
  level2Status: KycLevelStatusType;
  level3Status: KycLevelStatusType;
  level4Status: KycLevelStatusType;
  showLevel2Simple: boolean;
  enableLevel2Simple: boolean;
  enableLevel2: boolean;
  enableLevel3: boolean;
  enableLevel4: boolean;
  level2SimpleComment?: string;
  level2Comment?: string;
  level3Comment?: string;
  level4Comment?: string;
  comment?: string;
  clientStatus: KycClientStatusType;
  tncAgreementRequired: boolean;
  legacyKYCLevel?: KycLevelType;
  gracePeriod?: {
    levelName: ValidKycLevelType;
    finishAt: string;
  };
}

export const KycLevelEnum = {
  Level0: 'LEVEL_0',
  Level1: 'LEVEL_1',
  Level2Simple: 'LEVEL_2_SIMPLE',
  Level2: 'LEVEL_2',
  Level3: 'LEVEL_3',
  Level4: 'LEVEL_4',
} as const;

export type KycLevelType = valueof<typeof KycLevelEnum>;

export const KycLevelStatusEnum = {
  NotStarted: 'NOT_STARTED',
  InProgress: 'IN_PROGRESS',
  InReview: 'IN_REVIEW',
  Resubmit: 'RESUBMIT',
  Completed: 'COMPLETED',
  Rejected: 'REJECTED',
} as const;

export type KycLevelStatusType = valueof<typeof KycLevelStatusEnum>;

export const KycClientStatusEnum = {
  None: 'NONE',
  Pending: 'PENDING',
  Active: 'ACTIVE',
  Rejected: 'REJECTED',
  Closed: 'CLOSED',
  TncAgreementRequired: 'TNC_AGREEMENT_REQUIRED',
} as const;

export type KycClientStatusType = valueof<typeof KycClientStatusEnum>;

export const ValidKycLevels: KycLevelType[] = [
  KycLevelEnum.Level2Simple,
  KycLevelEnum.Level2,
  KycLevelEnum.Level3,
  KycLevelEnum.Level4,
];

export type ValidKycLevelType = Extract<KycLevelType, 'LEVEL_2_SIMPLE' | 'LEVEL_2' | 'LEVEL_3' | 'LEVEL_4'>;

export const isValidKycLevel = (lv: KycLevelType): lv is ValidKycLevelType => ValidKycLevels.includes(lv);

export const KycLevelTextMapper = {
  [KycLevelEnum.Level0]: 'Level 0',
  [KycLevelEnum.Level1]: 'Level 1',
  [KycLevelEnum.Level2Simple]: 'Level 2 Simple',
  [KycLevelEnum.Level2]: 'Level 2',
  [KycLevelEnum.Level3]: 'Level 3',
  [KycLevelEnum.Level4]: 'Level 4',
} as const;

export interface GetKycAccessTokenParams {
  levelName: ValidKycLevelType;
}
export interface GetKycAccessTokenResponse {
  accessToken: string;
}

export interface GetUserKYCIdentityResponse {
  name: string;
  dateOfBirth: string;
  country: string;
  nationality: string;
}
